import React, { FC, useContext, useEffect, useMemo, useState } from "react";
import { Box } from "@mui/material";
import { DataGrid, GridColDef, GridSelectionModel } from "@mui/x-data-grid";
import { DataContext } from "../../../Context/ContextWrapper";
import { CommonFieldsData, prensta } from "../../../../../../networking";

type ModuleRow = {
  id: string;
  nome: string;
  descrizione: string;
  tipoModulo: string;
  tipoStampa: string;
};

type Props = {
  selection: GridSelectionModel;
  onSelectionChange: (ids: GridSelectionModel, rows: ModuleRow[]) => void;
};

const columns: GridColDef[] = [
  { field: "nome", headerName: "Nome Modulo", flex: 1, minWidth: 220 },
  {
    field: "descrizione",
    headerName: "Descrizione Modulo",
    flex: 1,
    minWidth: 260,
  },
];

const PrintFormsTable: FC<Props> = ({ selection, onSelectionChange }) => {
  const context = useContext(DataContext);

  const [dataRows, setDataRows] = useState<ModuleRow[]>([]);

  const handleSelectionChange = (ids: GridSelectionModel) => {
    const selected = dataRows.filter((row) => ids.includes(row.id));
    onSelectionChange(ids, selected);
  };

  // Effettua la chiamata a prensta per ottenere i moduli di stampa
  useEffect(() => {
    const fetchPrintForms = async () => {
      try {
        const payloadPrensta: CommonFieldsData = {
          idPacate: context?.idPacate,
          aziendaPrenotazione: context?.aziendaPrenotazione,
        };
        const responsePrensta = await prensta(payloadPrensta);
        console.log({ responsePrensta });

        const grid = responsePrensta.data?.dati?.[0]?.grid.dati ?? [];

        const mappedRows: ModuleRow[] = grid.map((param: any) => ({
          id: String(param.idParstad),
          nome: param.moduloStampa,
          descrizione: param.Descrizione,
          tipoModulo: String(param.tipoModulo ?? "2"),
          tipoStampa: String(param.tipoStampa ?? "S"),
        }));

        setDataRows(mappedRows);

        const defaultSelectedRows = grid
          .filter((param: any) => param.selezioneDefault === "1")
          .map((param: any) => String(param.idParstad));

        /* In futuro sarà necessario implementare il filtro anche per le email */
        // const defaultMailSelectedRows = grid
        //   .filter((param: any) => param.abilEmail === "1")
        //   .map((param: any) => String(param.idParstad));

        if (defaultSelectedRows.length > 0) {
          handleSelectionChange(defaultSelectedRows);
        }
      } catch (err) {
        console.error("Errore chiamata prensta:", err);
      }
    };
    fetchPrintForms();
  }, [context?.idPacate, context?.aziendaPrenotazione]);

  return (
    <Box
      sx={{
        width: "100%",
        border: "1px solid #E0E0E0",
        borderRadius: "8px",
        overflow: "hidden",
        bgcolor: "#fff",
        "& .MuiDataGrid-root": { border: "none" },
        "& .MuiDataGrid-columnHeaders": {
          backgroundColor: "#003267",
          color: "#fff",
          fontWeight: 700,
          borderBottom: "none",
        },
        "& .MuiDataGrid-columnHeadersInner": {
          borderTopLeftRadius: "8px",
          borderTopRightRadius: "8px",
          overflow: "hidden",
        },
        "& .MuiDataGrid-columnSeparator": { display: "none" },
        "& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-cell:focus": {
          outline: "none",
        },
        "& .MuiDataGrid-columnHeaderCheckbox .MuiSvgIcon-root": {
          color: "#fff",
        },
        "& .MuiDataGrid-row": { borderBottom: "1px solid #eee" },
        "& .MuiDataGrid-footerContainer": { display: "none" },
      }}
    >
      <DataGrid
        autoHeight
        rows={dataRows}
        columns={columns}
        density="compact"
        checkboxSelection
        disableSelectionOnClick
        disableColumnMenu
        hideFooter
        selectionModel={selection}
        onSelectionModelChange={handleSelectionChange}
        // Per visualizzare la paginazione basta riattivare questi
        // rowsPerPageOptions={[5]}
        // initialState={{ pagination: { page: 0, pageSize: 5 } }}
      />
    </Box>
  );
};

export default PrintFormsTable;
